module.exports = __webpack_public_path__ + "img/profile-bg.9d06590a.png";